import React, { useEffect, useState } from 'react';
import {
  dlsBrightBlue,
  dlsColorAttention,
  dlsColorModerate,
  dlsRed,
  Tooltip,
  TooltipButton,
} from '@americanexpress/dls-react';
import * as PropTypes from 'prop-types';
import { defaultTooltipMetaData } from './previewDefaults';

const getTheme = (tipType) => {
  switch (tipType) {
    case 'error':
      return dlsRed;
    case 'info':
      return dlsBrightBlue;
    case 'warning':
      return dlsColorModerate;
    default:
      return dlsColorAttention;
  }
};
export const FxFieldLabelTooltip = (props) => {
  const {
    id,
    field: f,
    isValueMissing,
    sectionToConsider,
  } = props;

  const field = { ...defaultTooltipMetaData, ...f };

  const [toolTipTheme, setToolTipTheme] = useState({});
  const [toolTipFilled, setToolTipFilled] = useState(false);
  const [toolTipMsg, setToolTipMsg] = useState('');
  const [showToolTip, setShowToolTip] = useState(false);
  const [tooltipPlacement, setTooltipPlacement] = useState('right');
  const [whiteTheme, setWhiteTheme] = useState(false);

  // eslint-disable-next-line complexity
  useEffect(() => {
    let tipType;
    let message;
    if (field?.mandatory && isValueMissing) {
      tipType = 'warning';
      message = field?.mandatoryMsg || 'Missing information'; // updated default message as part of new requirement
      setShowToolTip(true);
    } else if (field?.excMsgFunc) {
      const warningData = field?.excMsgFunc(sectionToConsider);
      tipType = warningData?.type || 'warning';
      message = warningData?.message || warningData;
      setToolTipFilled(warningData?.filled || false);
      setShowToolTip(message);
      setTooltipPlacement(warningData?.tooltipPlacement || 'right');
      setWhiteTheme(warningData?.messageTheme === 'white');
    } else {
      console.log('Nothing happened');
      setShowToolTip(false);
    }
    setToolTipMsg(message);
    setToolTipTheme(getTheme(tipType));
  }, [isValueMissing, field.mandatory, sectionToConsider]);

  return (
    <>
      {showToolTip
        && (
          <>
            <Tooltip
              id={`${id}-exception-tooltip`}
              triggerElement={(
                <div className="flex flex-align-center dls-bright-blue">
                  <TooltipButton
                    id={`${id}-exception-tooltip-button`}
                    icon={(
                      <field.icon
                        theme={toolTipTheme}
                        size="sm"
                        filled={toolTipFilled}
                        id={`${id}-exception-tooltip-button-icon`}
                      />
                    )}
                    theme={{ padding: '0px' }}
                  />
                  {field.messageTxt && <p>{field.messageTxt}</p>}
                </div>
              )}
              placement={tooltipPlacement || 'right'}
              forcePlacement={true}
              style={{
                marginLeft: '3px',
                bottom: '5px',
              }}
              theme={whiteTheme ? {
                '> div:nth-child(1)': {
                  backgroundColor: 'white !imporatnt',
                },
                '> div:nth-child(2)': {
                  backgroundColor: 'white !important',
                  color: 'black !important',
                  fontWeight: 'normal !important',
                },
              } : undefined}
            >
              {toolTipMsg}
            </Tooltip>
          </>
        )}
    </>
  );
};

FxFieldLabelTooltip.displayName = 'FxFieldLabelTooltip';

FxFieldLabelTooltip.propTypes = {
  sectionToConsider: PropTypes.oneOfType(
    [PropTypes.shape({}), PropTypes.array]
  ),
  id: PropTypes.string,
  field: PropTypes.shape({
    mandatory: PropTypes.bool,
    mandatoryMsg: PropTypes.string,
    excMsgFunc: PropTypes.func,
  }),
  isValueMissing: PropTypes.bool,
};
